/**
 * DTO object for creation of Location.
 */
export class LocationDto {
  id: number;
  name: string;
  nameRemap: string;
  locationId: string;
  pieMerchantId?: number;
}
